export const profileFilterOptions = [
    { label: 'Favourited courses', value: 'favourite' },
    { label: 'Paid courses', value: 'paid' },
    { label: 'Unpaid courses', value: 'unpaid' },
    { label: 'CPL eligible courses', value: 'cpl_eligible' },
    { label: 'Non-CPL eligible courses', value: 'non_cpl_eligible' },
  ]